module.exports = __webpack_public_path__ + "db0628bc1ef0a8c6a5c53e7af84c6982.otf";